import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { loginApi } from '../services/api';
import { AuthContext } from '../context/AuthContext';
import { Card, CardContent, TextField, Button, Typography, Container, Box } from '@mui/material';

const Login = () => {
    const [identifier, setIdentifier] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const { login } = useContext(AuthContext);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        try {
            const data = await loginApi(identifier, password);
            login(data.jwt, data.user);
            navigate('/home');
        } catch (err) {
            setError(err.message);
        }
    };

    return (
        <Container maxWidth="sm">
            <Card sx={{ mt: 8 }}>
                <CardContent>
                    <Typography variant="h4" gutterBottom align="center">Login</Typography>
                    <Box component="form" onSubmit={handleSubmit} noValidate>
                        <TextField
                            label="Email"
                            type="email"
                            fullWidth
                            margin="normal"
                            value={identifier}
                            onChange={(e) => setIdentifier(e.target.value)}
                            required
                        />
                        <TextField
                            label="Password"
                            type="password"
                            fullWidth
                            margin="normal"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                        {error && <Typography color="error">{error}</Typography>}
                        <Button type="submit" variant="contained" fullWidth sx={{ mt: 2 }}>
                            Login
                        </Button>
                    </Box>
                </CardContent>
            </Card>
        </Container>
    );
};

export default Login;
